import React, {useContext,useEffect} from 'react';
import {Route, Redirect} from 'react-router-dom'
import AuthContext from '../../context/authContext/authContext'

const RutaCliente = ({ component: Component, ...props  }) => {

    const authContext = useContext(AuthContext);
    const { autenticado, cargando, usuarioAutenticado } = authContext;

    useEffect(() => {
        let mounted = true;
        if(mounted){
            usuarioAutenticado();
        }
        
        return function cleanup(){
            mounted = false;
        }
      
           // eslint-disable-next-line
    }, []);

    
    return ( 
        <Route { ...props } render={ props => !autenticado  && !cargando  ?  (
            <Redirect to="/" />
        )  : (
            <Component {...props} />
        ) } />

     );
}
 
export default RutaCliente;

